<template>
    <PopoverPanel>
        <slot></slot>
    </PopoverPanel>
</template>

<script>
import { PopoverPanel } from '@headlessui/vue'

export default {
    components: {
        PopoverPanel,
    },

    emits: ['closed'],
    // Other lifecycle hooks and options as needed

    beforeUnmount() {
        this.$emit('closed')
    },
}
</script>
